module.exports = __webpack_public_path__ + "static/media/bring-front.4d6e5e63.svg";